import { restClient } from '../../client';
import { BetterhelpReferralCoverage } from '../admin/betterhelpCoverage';

export type CoveredSession = {
  sessionDate: string;
  providerName: string;
  eapName: string;
  referralType: string;
};

export type PatientBetterhelpReferralCoverage = BetterhelpReferralCoverage & {
  coveredSessions: CoveredSession[];
};

export type PatientBetterhelpCoverageResponse = {
  data: PatientBetterhelpReferralCoverage[];
};

export const getPatientBetterhelpCoverage = async (patientId: string) =>
  restClient.request<PatientBetterhelpCoverageResponse>(`/api/v1/patient/${patientId}/betterhelp_coverage`, {
    method: 'GET',
  });
